<div class="modal-header bg-light border-bottom d-flex justify-content-between align-items-center">
  <h5 class="modal-title fw-bold">Media Player</h5>
  <div class="d-flex align-items-center gap-2">
    <span class="text-muted small">
      {{ currentIndex + 1 }} / {{ mediaList.length }}
    </span>
    <button
      type="button"
      class="btn-close"
      aria-hidden="true"
      (click)="close()"
    ></button>
  </div>
</div>

<div class="modal-body d-flex flex-column align-items-center justify-content-center position-relative" style="min-height: 400px">
  <!-- Navigation Arrows -->
  <button
    type="button"
    class="btn btn-light position-absolute start-0 top-50 translate-middle-y ms-3"
    (click)="previousMedia()"
    [disabled]="!canGoPrevious()"
    title="Previous Media"
    *ngIf="mediaList.length > 1"
  >
    <i class="bx bx-chevron-left font-size-24"></i>
  </button>

  <button
    type="button"
    class="btn btn-light position-absolute end-0 top-50 translate-middle-y me-3"
    (click)="nextMedia()"
    [disabled]="!canGoNext()"
    title="Next Media"
    *ngIf="mediaList.length > 1"
  >
    <i class="bx bx-chevron-right font-size-24"></i>
  </button>

  <!-- Image Display -->
  <ng-container *ngIf="mediaType === 'image'">
    <img
      [src]="mediaUrl"
      alt="Media Preview"
      class="img-fluid rounded-3"
      style="max-width: 100%; max-height: 70vh; object-fit: contain"
    />
  </ng-container>

  <!-- Video Display -->
  <ng-container *ngIf="mediaType === 'video'">
    <video
      #videoPlayer
      controls
      class="rounded-3"
      style="max-width: 100%; max-height: 70vh"
    >
      <source [src]="mediaUrl" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </ng-container>

  <!-- YouTube Video -->
  <ng-container *ngIf="mediaType === 'youtube'">
    <div class="ratio ratio-16x9 w-100">
      <iframe
        [src]="getYoutubeEmbedUrl()"
        title="YouTube video player"
        allowfullscreen
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      ></iframe>
    </div>
  </ng-container>

  <!-- Vimeo Video -->
  <ng-container *ngIf="mediaType === 'vimeo'">
    <div class="ratio ratio-16x9 w-100">
      <iframe
        [src]="getVimeoEmbedUrl()"
        title="Vimeo video player"
        allowfullscreen
        allow="autoplay; fullscreen; picture-in-picture"
      ></iframe>
    </div>
  </ng-container>

  <!-- Audio Display -->
  <ng-container *ngIf="mediaType === 'audio'">
    <div class="text-center">
      <div class="mb-4">
        <i class="bx bx-music font-size-48 text-primary"></i>
      </div>
      <audio
        #audioPlayer
        controls
        class="w-100"
        style="max-width: 400px"
      >
        <source [src]="mediaUrl" type="audio/mpeg" />
        Your browser does not support the audio element.
      </audio>
    </div>
  </ng-container>
</div>

<div class="modal-footer bg-light border-top">
  <button
    type="button"
    class="btn btn-secondary btn-sm"
    (click)="close()"
  >
    Close
  </button>
  <button
    type="button"
    class="btn btn-primary btn-sm"
    (click)="downloadMedia()"
    title="Download media"
  >
    <i class="bx bx-download me-1"></i> Download
  </button>
</div>
